import { PetProfile } from 'types/pet-profile';
import { omitNullableHandler } from 'utils/type-helper';

const keysToOmit: string[] = [
  'id',
  'lastTouched',
  'selectedFoodTypes',
  'selectedWetFoodTypes',
  'selectedTastePreferences',
  'selectedDislikedProteins',
  'selectedAllergies',
  'updatedAt',
  'name',
  'selectedWeight',
  'petType',
  'dateOfBirth',
  'bodyCondition',
  'neutered',
  'activityLevel',
  'kcalUpdatedAt',
  'dailyKcal',
  'hasSpecialNeeds',
];

/**
 * Convert segmentation store to array string for Ninetailed Trails or GA
 * Currently specific allergies and foodtype are omitted for business descion
 */
export default function convertProfileToArray({
  petProfile,
}: {
  petProfile: PetProfile;
}): Array<string> {
  return Object.entries(petProfile)
    .map(([key, value]) => {
      if (!keysToOmit.includes(key as keyof PetProfile)) {
        return value;
      }
    })
    .flat()
    .filter(omitNullableHandler)
    .sort();
}
